var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

require('jquery-validation');
require('jquery-validation/dist/additional-methods');       // Extra validation types


module.exports = function() {

    /*
     * Postal Code Validation
     * Modified from the provided 'additional-methods' to support:
     * - Case insensitive
     * - Optional space or dash
     */
    $.validator.addMethod('postalCodeCA', function( value, element ) {
        return this.optional( element ) || /^[ABCEGHJKLMNPRSTVXY]\d[A-Z][ -]?\d[A-Z]\d$/.test( value.toUpperCase() );
    }, 'Please specify a valid postal code (e.g. A1A 1A1)' );


    /*
     * Credit Card Expiry Date Validation
     * - MM/YY with months between 01-12 and years from 00-99
     */
    $.validator.addMethod('creditCardExpiry', function( value, element ) {
        return this.optional( element ) || /^(0[1-9]|1[012])\/\d{2}$/.test(value);
    }, 'Please enter a valid expiry date (e.g. 01/22)' );


    /*
     * No PO Box Validation
     * - Case insensitive
     */
    $.validator.addMethod('noPOBox', function( value, element ) {
        return this.optional(element) || ! /(P(OST)?\.?\s*O(FF(ICE)?)?\.?\s*((BOX)|(BIN)))|(^[^0-9]*((P(OST)?\.?\s*O(FF(ICE)?)?\.?)|((BOX)|(BIN))))/i.test(value);
    }, 'Please note: we do not ship to P.O. Boxes' );


    /*
     * Customize default creditcardtypes validation
     * Ignore all whitespace
     */
    $.validator.addMethod('creditcardtypesCustom', function(value, element, param) {

        value = value.replace(/\D/g, '');

        var validTypes = 0x0000;

        if (param.mastercard) {
            validTypes |= 0x0001;
        }
        if (param.visa) {
            validTypes |= 0x0002;
        }
        if (param.amex) {
            validTypes |= 0x0004;
        }
        if (param.dinersclub) {
            validTypes |= 0x0008;
        }
        if (param.enroute) {
            validTypes |= 0x0010;
        }
        if (param.discover) {
            validTypes |= 0x0020;
        }
        if (param.jcb) {
            validTypes |= 0x0040;
        }
        if (param.unknown) {
            validTypes |= 0x0080;
        }
        if (param.all) {
            validTypes = 0x0001 | 0x0002 | 0x0004 | 0x0008 | 0x0010 | 0x0020 | 0x0040 | 0x0080;
        }
        if (validTypes & 0x0001 && /^(5[12345])/.test(value)) {          // mastercard
            return value.length === 16;
        }
        if (validTypes & 0x0002 && /^(4)/.test(value)) {                 // visa
            return value.length === 16;
        }
        if (validTypes & 0x0004 && /^(3[47])/.test(value)) {             // amex
            return value.length === 15;
        }
        if (validTypes & 0x0008 && /^(3(0[012345]|[68]))/.test(value)) { // dinersclub
            return value.length === 14;
        }
        if (validTypes & 0x0010 && /^(2(014|149))/.test(value)) {        // enroute
            return value.length === 15;
        }
        if (validTypes & 0x0020 && /^(6011)/.test(value)) {              // discover
            return value.length === 16;
        }
        if (validTypes & 0x0040 && /^(3)/.test(value)) {                 // jcb
            return value.length === 16;
        }
        if (validTypes & 0x0040 && /^(2131|1800)/.test(value)) {         // jcb
            return value.length === 15;
        }
        if (validTypes & 0x0080) {                                       // unknown
            return true;
        }

        return false;
    }, 'Please enter a valid credit card number.');

};
